import { useContext, useEffect } from 'react';
import { HeaderActionsContext } from '../contexts/header-actions';

/**
 * Register actions on the right side of AppHeader (before warehouse menu).
 */
export function useHeaderActions(factory, deps) {
  const { setActions, clearActions } = useContext(HeaderActionsContext);

  useEffect(() => {
    setActions(factory());
    return () => clearActions();
  }, deps);
}
